module.exports = __webpack_public_path__ + "static/media/17.1bee5fe8.mp3";